import ForgotPassword from '../components/User/ForgotPassword';

export default function ForgotPasswordPage() {
  return (<ForgotPassword/>);
}
